import { setLabel } from './navLabels';
// config
import { SONNET_AUTH_ORIGIN, FEbaseURL } from '../../config';
// Do not show LeavingTooSoonPopUp for these routes
const invalidRoutesForLeavingTooSoonPopUp = ['/dashboard', '/error'];

const claimDraftURL = '/start-claim';

export const navLinks = (appLanguage, setNavLink, setIsLeavingSoSoonPopUpOpen) => [
  {
    isActive: window.location.href.includes('/account/dashboard'),
    href: `${SONNET_AUTH_ORIGIN}/#/account/dashboard`,
    onClick: (e) => { handleNavLinkClick(e, `${SONNET_AUTH_ORIGIN}/#/account/dashboard`, setNavLink, setIsLeavingSoSoonPopUpOpen); },
    label: setLabel('Dashboard', appLanguage),
  },
  {
    isActive: window.location.href.includes('/account/policies'),
    href: `${SONNET_AUTH_ORIGIN}/#/account/policies`,
    onClick: (e) => { handleNavLinkClick(e, `${SONNET_AUTH_ORIGIN}/#/account/policies`, setNavLink, setIsLeavingSoSoonPopUpOpen); },
    label: setLabel('My Policies', appLanguage),
  },
  {
    isActive: window.location.href.includes('/dashboard'),
    href: '/dashboard',
    onClick: (e) => { handleNavLinkClick(e, `${FEbaseURL}/dashboard`, setNavLink, setIsLeavingSoSoonPopUpOpen); },
    label: setLabel('Claims', appLanguage),
  },
  {
    isActive: window.location.href.includes('/account/connect'),
    href: `${SONNET_AUTH_ORIGIN}/#/account/connect`,
    onClick: (e) => { handleNavLinkClick(e, `${SONNET_AUTH_ORIGIN}/#/account/connect`, setNavLink, setIsLeavingSoSoonPopUpOpen); },
    label: setLabel('Offers', appLanguage),
  },
  {
    isActive: window.location.href.includes('/account/settings'),
    href: `${SONNET_AUTH_ORIGIN}/#/account/settings`,
    onClick: (e) => { handleNavLinkClick(e, `${SONNET_AUTH_ORIGIN}/#/account/settings`, setNavLink, setIsLeavingSoSoonPopUpOpen); },
    label: setLabel('Settings', appLanguage),
  },
];

export const handleNavLinkClick = (e, link, setNavLink, setIsLeavingSoSoonPopUpOpen) => {
  e.preventDefault();
  if (isLeavingTooSoonPopUpRequired()) {
    setIsLeavingSoSoonPopUpOpen(true);
    setNavLink(link);
  } else {
    window.open(link, '_self');
  }
};

export const isClaimInDraft = () => {
  const url = window.location.href;

  if (url.includes(claimDraftURL)) {
    return true;
  }
  return false;
};

export const isLeavingTooSoonPopUpRequired = () => {
  const { pathname } = window.location;

  if (invalidRoutesForLeavingTooSoonPopUp.includes(pathname)) {
    return false;
  }
  return true;
};
